import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_user = Atdgen_codec_runtime.Encode.string;
var read_user = Atdgen_codec_runtime.Decode.string;
var write_term = Atdgen_codec_runtime.Encode.string;
var read_term = Atdgen_codec_runtime.Decode.string;
var write_job = Atdgen_codec_runtime.Encode.string;
var read_job = Atdgen_codec_runtime.Decode.string;
var write_events = Atdgen_codec_runtime.Encode.string;
var read_events = Atdgen_codec_runtime.Decode.string;
var write_event = Atdgen_codec_runtime.Encode.string;
var read_event = Atdgen_codec_runtime.Decode.string;
var write_blob = Atdgen_codec_runtime.Encode.string;
var read_blob = Atdgen_codec_runtime.Decode.string;
var write_batch = Atdgen_codec_runtime.Encode.string;
var read_batch = Atdgen_codec_runtime.Decode.string;
export { read_user, write_user, read_term, write_term, read_job, write_job, read_events, write_events, read_event, write_event, read_blob, write_blob, read_batch, write_batch };
/* No side effect */